import { useAppDispatch, useAppSelector } from '@hooks';
import { DialogContentText, useMediaQuery, useTheme } from '@mui/material';
import { hideConfirm } from '@redux/actions';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from './Dialog';

const DialogConfirm: FC = () => {
  const dispatch = useAppDispatch();

  const { t } = useTranslation();
  const theme = useTheme();
  const isLgDown = useMediaQuery(theme.breakpoints.down('lg'));
  const { dialogConfirm } = useAppSelector((state) => state.app);

  const handleCancel = () => {
    dialogConfirm.onCancel?.();
    dispatch(hideConfirm());
  };

  const handleConfirm = () => {
    dialogConfirm.onConfirm?.();
    dispatch(hideConfirm());
  };

  return (
    <Dialog
      disableTransition
      maxWidth={isLgDown ? 'xs' : 'sm'}
      open={dialogConfirm.show}
      title={dialogConfirm.title}
      onCancel={handleCancel}
      onConfirm={handleConfirm}
    >
      <DialogContentText>{t(dialogConfirm.content!)}</DialogContentText>
    </Dialog>
  );
};

export default DialogConfirm;
